import { useQuery } from '@tanstack/react-query'
import { Client, clientsQuery } from '../features/clients'

export const useClients = (initialData?: Client[]) => useQuery(
  {
    ...clientsQuery(),
    initialData: initialData ?? undefined
  }
)
